function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 60,
  height: 60
}, React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 15,
  stroke: "black",
  strokeWidth: 30
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask1)"
}, React.createElement("g", {
  opacity: 0.636
}, React.createElement("path", {
  d: "M23.203 56.509C10.186 56.509 3 36.696 3 23.679C3 10.66 20.287 6 33.305 6C46.323 6 56.876 16.553 56.876 29.57C56.876 42.589 36.221 56.509 23.203 56.509Z",
  stroke: "#00C1F1"
}), React.createElement("path", {
  d: "M30.096 55.667C43.114 55.667 53.938 41.017 53.938 28C53.938 14.982 37.956 4 24.938 4C11.92 4 3.938 16.816 3.938 29.834C3.938 42.85 17.078 55.667 30.096 55.667Z",
  stroke: "#00C1F1"
})));

var Svg2 = function Svg2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2.4c07597e.svg";
export { ForwardRef as ReactComponent };